module.exports = __webpack_public_path__ + "images/522e5fb3c251ae76a9c868d836201c66e.svg";